/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Indicates the source of the location, we use multiple methods of estimating a users location
 */
export enum LocationSource {
  IP = 'ip',
  GPS = 'gps',
  CLOUDFRONT = 'cloudfront',
  TIMEZONE = 'timezone',
  MANUAL = 'manual',
  UNKNOWN = 'unknown',
}
